// Pure interpolation for animated viewport transitions. Scale interpolates
// exponentially (perceptually uniform zoom); the world point anchored at the
// screen center interpolates linearly — together a straight, non-wobbling
// camera path from A to B. from/to are {scale, x, y} (origin coordinates).
export function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function interpolateViewport(from, to, t, anchorX, anchorY) {
    if (t <= 0) return { scale: from.scale, x: from.x, y: from.y };
    if (t >= 1) return { scale: to.scale, x: to.x, y: to.y };
    const scale = from.scale * Math.pow(to.scale / from.scale, t);
    const fromCx = (anchorX - from.x) / from.scale;
    const fromCy = (anchorY - from.y) / from.scale;
    const toCx = (anchorX - to.x) / to.scale;
    const toCy = (anchorY - to.y) / to.scale;
    const cx = fromCx + (toCx - fromCx) * t;
    const cy = fromCy + (toCy - fromCy) * t;
    return { scale, x: anchorX - cx * scale, y: anchorY - cy * scale };
}

export function isNegligibleViewportDelta(from, to) {
    return (
        Math.abs(to.scale - from.scale) / from.scale < 0.001 &&
        Math.abs(to.x - from.x) < 0.5 &&
        Math.abs(to.y - from.y) < 0.5
    );
}
